import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { recordMenuVisit } from '@/utils/menu-visit'
import { Message } from 'element-ui'
NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/register', '/callScreen', '/purchaseRegister', '/supplierRegister'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {

  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      const hasRoles = store.getters.routesLists && store.getters.routesLists.length > 0

      console.log('+++路径地址+++++++++++++++++++++++++++++++++++');
      console.log(store.getters.routesLists);
      console.log('++++++++++++++++++++++++++++++++++++++');

      if (hasRoles) {
        next()
      } else {
         await store.dispatch('user/generateRoutes').then(accessRoutes => {
              router.addRoutes(accessRoutes.concat([{ path: '*', redirect: '/404', hidden: true }]))
              next({ ...to, replace: true })
            }).catch (error => {
              // 显示错误消息
              Message.error(error.message || '获取菜单权限失败')
              store.dispatch('user/resetToken').finally(() => {
                next(`/login?redirect=${to.path}`)
                NProgress.done()
            })
          })
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

function addChildren(children,arr){

  if(children == null || children.length < 1){
    return arr;
  }

  for(let i = 0 ; i < children.length ; i ++){

    let singleRoute = children[i];

    let routeObj = {
      path: `${singleRoute.path}`,
      name: `${singleRoute.name}`,
      meta: singleRoute.meta,
      component: () => import (`@/views/${singleRoute.component}.vue`)
    }

    if(singleRoute.children != null && singleRoute.children.length > 0){
      arr = addChildren(singleRoute.children,arr)
      routeObj.children = children
    }

    arr.push(routeObj);
  }

  return arr;
}



router.afterEach((to, from) => {
  // finish progress bar
  NProgress.done()

  // 记录菜单访问（异步执行，不阻塞）
  if (getToken() && to.path) {
    // 使用 setTimeout 确保在路由完全加载后记录
    setTimeout(() => {
      recordMenuVisit(to.path).catch(err => {
        // 静默失败，不影响用户体验
        console.error('记录菜单访问失败:', err)
      })
    }, 100)
  }
})



// WEBPACK FOOTER //
// ./src/permission.js